import React, { FC, useState } from "react";
import { useLocalAnalyticsState } from "../../../graphql/hooks";
import { Col, Collapse, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { AnalyticsFunnelViewSelectionToggle } from "../../buttons/analytics/AnalyticsFunnelViewSelectionToggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AnalyticsFunnelViewComparisonToggle } from "../../buttons/analytics/AnalyticsFunnelViewComparisonToggle";
import { getTree } from "../../../common/AnalyticsHelpers";
import { DailyBadges } from "./DailyBadges";
import { UserQueryBadges } from "./UserQueryBadges";
import { AnalyticsRevisions } from "../../modals/analytics/AnalyticsRevisions";
import { AnalyticsQuerySet, Project } from "../../../models/types";
import styles from "./FunnelBatchBuild.module.scss";

interface Props {
    project: Project;
    collapseTree?: AnalyticsQuerySet;
}

const FunnelProjectImplementation: FC<Props> = ({ project, collapseTree }) => {
    const analyticsState = useLocalAnalyticsState();
    const myTree =
        collapseTree === undefined
            ? getTree(analyticsState, Number(project.id), "projects")
            : collapseTree;
    const [show, setShow] = useState(
        (myTree?.selection?.revisions &&
            myTree.selection.revisions.length > 0) ||
            false
    );

    return (
        <div className={styles.container}>
            <Row className="align-items-center primary-background my-1 g-0">
                <Col
                    className={`${styles.selectionToggleCol} d-flex align-items-center`}
                >
                    <AnalyticsFunnelViewSelectionToggle
                        reference="project"
                        className="mx-2"
                        project={project}
                    />
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 550, hide: 100 }}
                        overlay={
                            <Tooltip id="funnel-project-tooltip">
                                Project name
                            </Tooltip>
                        }
                    >
                        <span
                            onClick={() => setShow(!show)}
                            className="ps-2 mouseHover medium-font"
                        >
                            {project.name}
                        </span>
                    </OverlayTrigger>
                    <AnalyticsFunnelViewComparisonToggle
                        reference="project"
                        className="ms-2"
                        project={project}
                    />
                    <FontAwesomeIcon
                        onClick={() => setShow(!show)}
                        className="mx-2 mouseHover color-secondary"
                        icon={show ? faChevronUp : faChevronDown}
                        size="xs"
                    />
                </Col>
                <Col className={styles.analyticsCol}>
                    <DailyBadges reference="project" referenceId={project.id} />
                </Col>
                <Col className={styles.analyticsCol}>
                    <UserQueryBadges
                        reference="project"
                        referenceId={project.id}
                    />
                </Col>
                <Col className={styles.infoIconCol}></Col>
            </Row>
            <Collapse in={show}>
                <div>
                    <AnalyticsRevisions project={project} show={show} />
                </div>
            </Collapse>
        </div>
    );
};

export const FunnelProject = React.memo(FunnelProjectImplementation);
